document.addEventListener('DOMContentLoaded', function (){
   if (document.querySelector('.body-template-product .product__custom-order')) {
       const customOrderSwitchers = document.querySelectorAll('.product__custom-order-radio[name="custom-order"]');

       customOrderSwitchers.forEach(function (item){
           if (window.location.href.includes('contact_posted=true#CustomOrder')) {
               formPostedSuccessfully();
           }

           item.addEventListener('change', function (){
               switchCustomOrder(this.value);
           })
       });

       function switchCustomOrder(active) {
           const actionItems = [
               '.product-form',
               '.inventory',
               '.product-parameters'
           ];

           if (active === 'Yes') {
               document.querySelector('.product__custom-order').classList.add('active');
               actionItems.forEach(function (item){
                   if (document.querySelector(item)){
                       document.querySelector(item).style.display = 'none';
                   }
               })
           } else {
               document.querySelector('.product__custom-order').classList.remove('active');
               actionItems.forEach(function (item){
                   if (document.querySelector(item)){
                       document.querySelector(item).style.display = 'block';
                   }
               })
           }
       }

       function formPostedSuccessfully() {
           const actionItems = [
               '.product__custom-order-switcher',
               '.contact__text',
               '.product-form',
               '.inventory',
               '.product-parameters',
               '.contact__bottom'
           ];

           document.querySelector('.product__custom-order').classList.add('active');
           actionItems.forEach(function (item){
               if (document.querySelector(item)){
                   document.querySelector(item).style.display = 'none';
               }
           })
           document.querySelectorAll('.field').forEach(function (item){
               item.style.display = 'none';
           });

       }
   }

   setTimeout(function (){
       if (document.querySelector('.body-template-cart .recently-viewed .loading-overlay')) {
           document.querySelector('.body-template-cart .recently-viewed .loading-overlay').remove();
       }
   }, 1000)

    if (document.querySelector('.body-template-page-create-order')){
        document.querySelector('a[href="#order"]').addEventListener('click', function (){
            const element = document.querySelector(".custom-order-form");

            element.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        });
    }
});